/**
 * Formato deterministic de numeros en estilo es-ES (separador de miles ".").
 *
 * Usar SIEMPRE en lugar de Number.prototype.toLocaleString('es-ES') en cualquier
 * codigo que se ejecute tanto en SSR como en CSR. ICU/CLDR puede dar resultados
 * distintos entre Node (server) y el navegador (cliente) — concretamente:
 *
 *   Node 20 + ICU 78  ->  (5000).toLocaleString('es-ES') === '5000'
 *   Chromium reciente ->  (5000).toLocaleString('es-ES') === '5.000'
 *
 * Ese desajuste rompe la hidratacion (React error #329 / #418) y deja
 * componentes con `opacity:0` invisibles para siempre. Esta funcion garantiza
 * que server y cliente generen el mismo string.
 */
export function formatNumberES(value: number): string {
  if (!Number.isFinite(value)) return String(value);
  const sign = value < 0 ? '-' : '';
  const [intPart, decPart] = Math.abs(value).toString().split('.');
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decPart ? `${sign}${grouped},${decPart}` : `${sign}${grouped}`;
}

/**
 * Formato monetario es-ES (separador miles "." y decimal ",", simbolo "€" al
 * final separado por espacio fino). Deterministic, no usa Intl para evitar
 * mismatches SSR/CSR derivados de versiones distintas de CLDR.
 */
export function formatPriceES(value: number): string {
  if (!Number.isFinite(value)) return String(value);
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);
  const [intPart, decRaw = ''] = abs.toFixed(2).split('.');
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sign}${grouped},${decRaw} €`;
}
